import {
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { IFlashyServerResponse, IUpgradeRequired } from '@flashy/store';
import { ModalsService } from '@services/modals/modals.service';

function eventIsResponse(
  event: HttpEvent<unknown>
): event is HttpResponse<IFlashyServerResponse<IUpgradeRequired>> {
  return event.type === HttpEventType.Response;
}

export const upgradeRequiredInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const modalsService = inject(ModalsService);
  return next(req).pipe(
    switchMap((event: HttpEvent<unknown>) => {
      if (eventIsResponse(event) && event.body.data?.upgrade) {
        return modalsService.upgradeMessage(event.body.data).pipe(
          switchMap((level) =>
            modalsService.upgrade(level, 'upgrade_response')
          ),
          switchMap(() => next(req))
        );
      } else {
        return of(event);
      }
    })
  );
};
